import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'ui';
import { routes } from 'constants/config';

const Invite = ({ session, event }) =>
  session && (
    <Button
      icon="envelope"
      url={routes.IN_PERSON_TRAINING.SESSION_INVITATIONS(event.id, session.id)}
      className="mr-8"
      small
      fullWidth
    >
      {t('in_person_training.invite_users.invite')}
    </Button>
  );

const mapStateToProps = state => ({
  event: state.event,
  session: state.event.next_session ? state.event.next_session : null,
});

export default connect(mapStateToProps)(Invite);
